// extracted by mini-css-extract-plugin
module.exports = {"layout":"PremiumsMonthly_layout__2bLZv","controls":"PremiumsMonthly_controls__3gIQk","current":"PremiumsMonthly_current__Urth_","history":"PremiumsMonthly_history__HXSXX"};